<template>
  <div class="card-form">
    <PageMain
    :isShowLaborPrice="isShowLaborPrice"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <template slot-scope="{ form }">
          <b-button
            v-if="allow('E')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="exportFile(form)"
          >
            {{ '导出' }}
            <i class="el-icon-download" />
          </b-button>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <EditForm
      v-if="openEditDialogOptions.editFormVisible"
      :visible.sync="openEditDialogOptions.editFormVisible"
      :disabled="openEditDialogOptions.disabled"
      :title="openEditDialogOptions.title"
      :pendingGoodsPackageWorklogCode="
        openEditDialogOptions.pendingGoodsPackageWorklogCode
      "
      :pendingGoodsCode="openEditDialogOptions.pendingGoodsCode"
      @reload="reload"
    ></EditForm>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
        custCode:
          isShowLaborPrice == 'Y'
            ? 'factory-pRRecord-laborPrice'
            : 'factory-pRRecord-not-laborPrice',
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form'
import ChooseTemplate from '@/views/factory/components/choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EditForm, ChooseTemplate },
  data() {
    return {
      usePage: true,
      isShowLaborPrice: 'N',
      openEditDialogOptions: {
        editFormVisible: false,
        pendingGoodsPackageWorklogCode: '',
      },
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'factory-packReportRecord',
        searchForm: {},
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingGoodsPackageWorkLogListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.isShowLaborPrice = res.body.isShowLaborPrice
          const param = res.body?.list
          const { pageSize, curPage, count, data } = param
          this.tableData = data || []
          this.page.pageTotal = count
          this.page.pageSize = pageSize
          this.page.curPage = curPage
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({
      pendingGoodsPackageWorklogCode,
      menuType,
      pendingGoodsCode,
    }) {
      const types = {
        add: '新增包装报工记录信息',
        edit: '编辑包装报工记录信息',
        detail: '包装报工记录详情',
      }

      this.openEditDialogOptions.editFormVisible = true
      this.openEditDialogOptions.disabled = menuType == 'detail'
      this.openEditDialogOptions.title = types[menuType]
      this.openEditDialogOptions.pendingGoodsPackageWorklogCode = pendingGoodsPackageWorklogCode
      this.openEditDialogOptions.pendingGoodsCode = pendingGoodsCode
    },
    exportFile(form) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = {
        ...form,
      }
    },
  },
}
</script>
